var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCar = function SvgCar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 23,
    viewBox: "0 0 14.8 12.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.6 4.231H2.14l.547-2.646A1.23 1.23 0 0 1 3.917.6h6.935a1.23 1.23 0 0 1 1.2.985zM10.446 6.939h.616M3.677 6.939h.616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.908 4.231H1.83A1.23 1.23 0 0 0 .6 5.462v2.954a1.23 1.23 0 0 0 1.23 1.23v1.108a.923.923 0 0 0 .923.923h.861a.923.923 0 0 0 .924-.923V9.647H10.2v1.107a.923.923 0 0 0 .923.923h.862a.923.923 0 0 0 .923-.923V9.647a1.23 1.23 0 0 0 1.23-1.231V5.462a1.23 1.23 0 0 0-1.23-1.23"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCar);
export default ForwardRef;